import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrencyDollarCircle2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "currency-dollar-circle" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 12,
			r: 10.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15,7.5H10.789A1.662,1.662,0,0,0,9,9.289c0,1.961,6,3.461,6,5.422A1.757,1.757,0,0,1,13.211,16.5H9"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 7.5,
			x2: 12,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 18.75,
			x2: 12,
			y2: 16.5
		})
	]
});
export default SvgCurrencyDollarCircle2;
